import axios from "axios";
import Cookies from "js-cookie";
import helpers from "../../Helpers";
import { receiveServerErrors } from "../../Shared/Errors/errorActions";

export const REQUEST_HOME_PAGE = "REQUEST_HOME_PAGE";
export const RECEIVE_HOME_PAGE = "RECEIVE_HOME_PAGE";
export const RECEIVE_VIP_HOME_PAGE = "RECEIVE_VIP_HOME_PAGE";
export const RECEIVE_INFLUENCER_NAMES = "RECEIVE_INFLUENCER_NAMES";
export const RECEIVE_VIP_INFLUENCER_VIDEOS = "RECEIVE_VIP_INFLUENCER_VIDEOS";
export const REQUEST_VIP_INFLUENCER_VIDEOS = "REQUEST_VIP_INFLUENCER_VIDEOS";
export const REQUEST_GAME_VIDEOS = "REQUEST_GAME_VIDEOS";
export const RECEIVE_GAME_VIDEOS = "RECEIVE_GAME_VIDEOS";
export const REQUEST_INFLUENCER_VIDEO_NOTES = "REQUEST_INFLUENCER_VIDEO_NOTES";
export const RECEIVE_INFLUENCER_VIDEO_NOTES = "RECEIVE_INFLUENCER_VIDEO_NOTES";
export const RECEIVE_INFLUENCER_VIDEO_NOTE = "RECEIVE_INFLUENCER_VIDEO_NOTE";

export const REQUEST_INFLUENCER_DAILY_TRACKINGS_DATA =
  "REQUEST_INFLUENCER_DAILY_TRACKINGS_DATA";
export const RECEIVE_INFLUENCER_DAILY_TRACKINGS_DATA =
  "RECEIVE_INFLUENCER_DAILY_TRACKINGS_DATA";
export const REQUEST_VIDEO_URL = "REQUEST_VIDEO_URL";
export const RECEIVE_VIDEO_URL = "RECEIVE_VIDEO_URL";
export const REQUEST_DROPBOX_VIDEO_URL = "REQUEST_DROPBOX_VIDEO_URL";
export const RECEIVE_DROPBOX_VIDEO_URL = "RECEIVE_DROPBOX_VIDEO_URL";
export const REQUEST_COMPETITORS_BRAND = "REQUEST_COMPETITORS_BRAND";
export const RECEIVE_COMPETITORS_BRAND = "RECEIVE_COMPETITORS_BRAND";
export const UPDATE_GRAPH_TYPE = "UPDATE_GRAPH_TYPE";
export const HOME_ACTIVE_TAB = "HOME_ACTIVE_TAB";
export const REQUEST_HOME_PAGE_GRAPH = "REQUEST_HOME_PAGE_GRAPH";
export const RECEIVE_HOME_PAGE_GRAPH = "RECEIVE_HOME_PAGE_GRAPH";

const requestHomePage = () => ({ type: REQUEST_HOME_PAGE });
const receiveHomePage = (data) => ({ type: RECEIVE_HOME_PAGE, data });

const requestHomePageGraph = (url) => ({
  type: REQUEST_HOME_PAGE_GRAPH,
  data: { url },
});
const receiveHomePageGraphs = (data) => ({
  type: RECEIVE_HOME_PAGE_GRAPH,
  data,
});

const receiveVipHomePage = (data) => ({ type: RECEIVE_VIP_HOME_PAGE, data });

export const receiveInfluencerVideos = (recentVideos) => ({
  type: RECEIVE_VIP_INFLUENCER_VIDEOS,
  recentVideos,
});

export const receiveGameVideos = (data) => ({
  type: RECEIVE_GAME_VIDEOS,
  data,
});

export const receiveInfluencerDailyTrackingData = (engagementIndexData) => ({
  type: RECEIVE_INFLUENCER_DAILY_TRACKINGS_DATA,
  engagementIndexData,
});

export const requestVIPInfluencerVideoUrl = () => ({
  type: REQUEST_VIDEO_URL,
});

export const receiveVIPInfluencerVideoUrl = (video_url) => ({
  type: RECEIVE_VIDEO_URL,
  video_url,
});

export const requestDropBoxVideoUrl = () => ({
  type: REQUEST_DROPBOX_VIDEO_URL,
});

export const receiveDropBoxVideoUrl = (dropbox_video) => ({
  type: RECEIVE_DROPBOX_VIDEO_URL,
  dropbox_video,
});

export const requestCompetitorsBrand = () => ({
  type: REQUEST_COMPETITORS_BRAND,
});

const receiveCompetitorsBrand = (competitors_brand) => ({
  type: RECEIVE_COMPETITORS_BRAND,
  competitors_brand,
});

export const updateGraphType = (status) => ({
  type: UPDATE_GRAPH_TYPE,
  status,
});

export const updateActiveTab = (activeTab) => ({
  type: HOME_ACTIVE_TAB,
  activeTab,
});

export const fetchHomePage = (vip) => (dispatch) => {
  dispatch(requestHomePage());
  helpers
    .axiosGetCall(`/home`, {
      vip,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    })
    .then(({ response, res }) => {
      if (vip) {
        dispatch(receiveVipHomePage(response));
      } else {
        dispatch(receiveHomePage(response));
      }
    })
    .catch((error) => {
      dispatch(receiveServerErrors(error.response));
    });
};
// Introducing Redux
export const fetchHomePageGraphs =
  ({ url, duration, competitors_brands }) =>
  (dispatch) => {
    dispatch(requestHomePageGraph(url));
    helpers
      .axiosGetCall(`/home/${url}`, {
        duration,
        ...(competitors_brands ? { competitors_brands } : {}),
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
      .then(({ response, res }) => {
        dispatch(
          receiveHomePageGraphs({ url, duration, competitors_brands, response })
        );
      })
      .catch((error) => {
        // dispatch(receiveServerErrors(error.response));
      });
  };

export const fetchCompetitorsBrand = (competitors_brands) => (dispatch) => {
  dispatch(requestCompetitorsBrand());
  helpers
    .axiosGetCall(`/home`, {
      competitors_brands,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    })
    .then(({ response, res }) => {
      dispatch(receiveCompetitorsBrand({ [competitors_brands]: response }));
    })
    .catch((xhr) => {
      dispatch(receiveServerErrors(error.response));
    });
};

export const fetchHomeGraphData = ({
  url,
  duration,
  competitors_brands,
  platform,
}) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/home/${url}`, {
        duration,
        platform,
        ...(competitors_brands ? { competitors_brands } : {}),
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const fetchHomeWordCloud = (param) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/home/competitor_word_cloud_data`, {
        ...param,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

// export const fetchHomeWordCloudData = (param) =>
// new Promise((resolve, reject) => {
//   helpers
//     .axiosGetCall(`/home/duration_wise_your_word_cloud`, {
//       ...param,
//       brand_id: Cookies.get("bId"),
//       user_id: Cookies.get('uId')
//     })
//     .then(({ response, res }) => {
//       resolve(response);
//     })
//     .catch((error) => {
//       reject(error);
//     });
// });

export const fetchUploadVideoDetail = (url, video_url) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(url, {
        video_url,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const isDropboxVideoPresent = (url, dropbox_id) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(url, {
        dropbox_id,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const getVideoUploadDetails = (param) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/users/video_upload_details`, {
        ...param,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const uploadBmVideo = (param) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/jwt_api${param.url}`,
        param.formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const uploadBmDenaliVideo = (param) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        // `${process.env.REACT_APP_BASE_URL}/jwt_api${param.url}`,
        `${process.env.REACT_APP_DENALI_BASE_URL}/video/submit-video-url`,
        param.formData,
        {
          headers: {
            "content-type": "multipart/form-data",
            // 'x-api-key':  `${process.env.REACT_APP_DENALI_API_TOKEN}`,
            // Authorization: `${process.env.REACT_APP_DENALI_API_TOKEN}`
            Authorization: `Bearer ${Cookies.get("jwt")}`,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const fetchVideoMetadata = (params) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_DENALI_BASE_URL}/video-metadata`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("jwt"),
        },
        params: {
          ...params,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const getVideoUploadUrl = (data, fileExtension) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_DENALI_BASE_URL}/video/create-upload-url/${fileExtension}`,
        data,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${Cookies.get("jwt")}`,
          },
        }
      )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export const uploadVideoToAWS = (uploadURL, videoFile) =>
  new Promise((resolve, reject) => {
    axios
      .put(uploadURL, videoFile, {
        headers: { "Content-Type": videoFile.type },
      })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export const getVideoFromDenaliAPI = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_DENALI_BASE_URL}/video/${id}`, {
        headers: {
          "content-type": "application/json",
          "x-api-key": process.env.REACT_APP_DENALI_API_TOKEN,
          Authorization: process.env.REACT_APP_DENALI_API_TOKEN,
        },
      })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export const getSingleVideoDetails = (id) =>
  new Promise((resolve, reject) => {
    helpers
      .axiosGetCall(`/videos/${id}/video_associations`, {})
      .then(({ response, res }) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const fetchInstagramVideoMetadata = (videoUrl) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_DENALI_BASE_URL}/instagram_videos/fetch_videos_details`,
        { videoUrl },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("jwt")}`,
          },
        }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
